<template>
    <Head>
        <title>Noticias</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-noticias.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Noticias</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">

            <div class="row">
                <div class="col-lg-6" v-if="noticias.current_page==1">
                    <NoticiaBox :item="noticias.data[0]" :portada="true" :clase="'tarjeta-noticia tarjeta-noticia--destacada'" :truncate="false" />
                </div>
                <div class="col-lg-6" v-if="noticias.current_page==1">
                    <NoticiaBox v-for="(item, index) in noticias.data.slice(1,4)" :key="index"  :item="item" :truncate="false" />
                </div>
                <div class="col-lg-3" v-for="(item, index) in (noticias.current_page==1)?noticias.data.slice(4):noticias.data" :key="index">
                    <NoticiaBox :item="item" :clase="'tarjeta-noticia tarjeta-noticia--col'" :truncate="false" />
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <Paginacion :links="noticias.links"/>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import NoticiaBox from '../../Shared/Noticias/NoticiaBox.vue'
import Paginacion from '../../Shared/Paginacion.vue'

export default {
    props: {
        noticias: Object,
    },
    components: { Paginacion, NoticiaBox }
}
</script>
<style scoped>
</style>
